<!-- ********************************Spinner code start**************************-->
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..."
  type="ball-scale-multiple"></ngx-spinner>
<!-- ******************************spinner code ends***************************-->

<!-- ********************************Rack File Upload Section******************** -->

<div *ngIf="data.type === 'Rack'">
  <h1 *ngIf="!uploadConfirmation && !rackUploadError && !rackDataError" mat-dialog-title>{{'Are you sure to upload' | translate}}
    {{data.file.name}}</h1>
  <h1 *ngIf="uploadConfirmation && !rackUploadError && !rackDataError" mat-dialog-title>{{'Uploaded Successfully' | translate}}</h1>
  <h1 *ngIf="!uploadConfirmation && rackUploadError && !rackDataError" mat-dialog-title>{{errorResponseMessage}}</h1>
  <div *ngIf="!uploadConfirmation && rackUploadError && rackDataError">
    <h1 class="errorHead" mat-dialog-title> {{'Error Found' | translate}}</h1>
    <div class="errorsList" *ngIf="rackUploadEntityErrors.length > 0">
    <div *ngFor="let element of rackUploadEntityErrors">
      <p class="errorDetails">{{element}}</p>
    </div>
  </div>
  <div class="errorsList" *ngIf="rackErrorMessage">
    <p class="errorDetails">{{rackErrorMessage}}</p>
  </div>
    <h3 mat-dialog-title>{{'Please recheck the file and upload again' | translate}}</h3>
  </div>
  <div mat-dialog-actions class="fileUploadActionButtons">
    <div *ngIf="!uploadConfirmation && !rackUploadError && !rackDataError">
      <button class="okButton" mat-button (click)="confirmUpload(data.type)" cdkFocusInitial>{{'Yes' | translate}}</button>
      <button class="cancelButton" mat-button (click)="onNoClick()">{{'Cancel' | translate}}</button>
    </div>
    <div *ngIf="uploadConfirmation && !rackUploadError && !rackDataError" class="confirmedUploadAction">
      <button class="confirmCloseButton" mat-button (click)="closePopup()">{{'Close' | translate}}</button>
    </div>
    <div *ngIf="!uploadConfirmation && rackUploadError && !rackDataError" class="confirmedUploadAction">
      <button class="confirmCloseButton" mat-button (click)="closePopup()">{{'Close' | translate}}</button>
    </div>
    <div *ngIf="!uploadConfirmation && rackUploadError && rackDataError" class="confirmedUploadAction">
      <button class="confirmCloseButton" mat-button (click)="closePopup()">{{'Close' | translate}}</button>
    </div>
  </div>
</div>

<!-- ********************************Nouba File Upload Section******************** -->
<div *ngIf="data.type === 'Nouba'">

  <h1 *ngIf="!uploadConfirmation && !noubaUploadError && !noubaDataError" mat-dialog-title>{{'Are you sure to upload' | translate}}
    {{data.file.name}}</h1>
  <h1 *ngIf="uploadConfirmation && !noubaUploadError && !noubaDataError" mat-dialog-title>{{'Uploaded Successfully' | translate}}</h1>
  <h1 *ngIf="!uploadConfirmation && noubaUploadError && !noubaDataError" mat-dialog-title>{{errorResponseMessage}}</h1>
  <div *ngIf="!uploadConfirmation && noubaUploadError && noubaDataError">
    <h1 class="errorHead" mat-dialog-title> {{'Error Found' | translate}}</h1>
    <div  class="errorsList" *ngIf="noubaUploadEntityErrors.length">
        <div *ngFor="let element of noubaUploadEntityErrors">
            <p class="errorDetails">{{element}}</p>
          </div>
    </div>
    <div class="errorsList" *ngIf="noubaErrorMessage">
        <p class="errorDetails">{{noubaErrorMessage}}</p>
      </div>
    <h3 mat-dialog-title>{{'Please recheck the file and upload again' | translate}}</h3>
  </div>
  <div mat-dialog-actions class="fileUploadActionButtons">
    <div *ngIf="!uploadConfirmation && !noubaUploadError && !noubaDataError">
      <button class="okButton" mat-button (click)="confirmUpload(data.type)" cdkFocusInitial>{{'Yes' | translate}}</button>
      <button class="cancelButton" mat-button (click)="onNoClick()">{{'Cancel' | translate}}</button>
    </div>
    <div *ngIf="uploadConfirmation && !noubaUploadError && !noubaDataError" class="confirmedUploadAction">
      <button class="confirmCloseButton" mat-button (click)="closePopup()">{{'Close' | translate}}</button>
    </div>
    <div *ngIf="!uploadConfirmation && noubaUploadError && !noubaDataError" class="confirmedUploadAction">
      <button class="confirmCloseButton" mat-button (click)="closePopup()">{{'Close' | translate}}</button>
    </div>
    <div *ngIf="!uploadConfirmation && noubaUploadError && noubaDataError" class="confirmedUploadAction">
      <button class="confirmCloseButton" mat-button (click)="closePopup()">{{'Close' | translate}}</button>
    </div>
  </div>
</div>

<!-- ***********************************Rack Code Table Editing Section******************************* -->

<div *ngIf="data.type === 'EditRack'">

  <!-- *********Edit Rack Confirmation Sections**** -->

  <div *ngIf="!rackEditingWindow && !editRackSuccess && !editRackError">
    <h3>{{getEditMessage('rack')}}
      <!-- {{'Do you want to edit rack information for' | translate}} "{{data.rackData.rackCode}}" -->
    </h3>
    <div mat-dialog-actions class="fileUploadActionButtons">
      <div>
        <button class="cancelButton" mat-button (click)="onNoClick()">{{'Cancel' | translate}}</button>
        <button class="okButton" mat-button (click)="confirmEditProcess()" cdkFocusInitial>{{'Yes' | translate}}</button>
      </div>
    </div>
  </div>

  <!-- *********Edit Rack Sections**** -->

  <div class="rackEdit" *ngIf="rackEditingWindow && !editRackSuccess && !editRackError">
      <form class="form" name="rackEditForm" [formGroup]="rackEditForm" >
    <h1 mat-dialog-title>{{'Edit Rack Code' | translate}}</h1>
    <mat-table #table [dataSource]="dataSource">

      <ng-container matColumnDef="rackCode">
        <mat-header-cell *matHeaderCellDef>{{'Rack Code' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-form-field>
            <input matInput [value]="element.rackCode" name="rackCode" [formControl]="rackCodeControl" [(ngModel)]="element.rackCode">
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="drivingDirection">
        <mat-header-cell *matHeaderCellDef> {{'Driving Direction' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-form-field>
            <input matInput [value]="element.drivingDirection" name="drivingDirection" [formControl]="rackdrivingDirectionControl" [(ngModel)]="element.drivingDirection">
            <mat-error *ngIf="rackdrivingDirectionControl.invalid">{{getRequiredNumberErrorMessage(rackdrivingDirectionControl)}}</mat-error>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="x">
        <mat-header-cell *matHeaderCellDef> {{'Coordinate X' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-form-field>
            <input matInput [value]="element.x" name="x"  [formControl]="rackXControl" [(ngModel)]="element.x">
            <mat-error *ngIf="rackXControl.invalid">{{getRequiredNumberErrorMessage(rackXControl)}}</mat-error>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="y">
        <mat-header-cell *matHeaderCellDef> {{'Coordinate Y' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-form-field>
            <input matInput [value]="element.y"  name="y"  [formControl]="rackYControl" [(ngModel)]="element.y">
            <mat-error *ngIf="rackYControl.invalid">{{getRequiredNumberErrorMessage(rackYControl)}}</mat-error>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="depth">
        <mat-header-cell *matHeaderCellDef> {{'Size Depth(x)' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-form-field>
            <input matInput [value]="element.depth" name="depth"  [formControl]="rackDepthControl" [(ngModel)]="element.depth">
            <mat-error *ngIf="rackDepthControl.invalid">{{getRequiredNumberErrorMessage(rackDepthControl)}}</mat-error>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="width">
        <mat-header-cell *matHeaderCellDef> {{'Size Width(y)' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-form-field>
            <input matInput [value]="element.width"  name="width" [formControl]="rackWidthControl" [(ngModel)]="element.width">
            <mat-error *ngIf="rackWidthControl.invalid">{{getRequiredNumberErrorMessage(rackWidthControl)}}</mat-error>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="height">
        <mat-header-cell *matHeaderCellDef> {{'Size Height(z)' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-form-field>
            <input matInput [value]="element.height" name="height" [formControl]="rackHeightControl" [(ngModel)]="element.height">
            <mat-error *ngIf="rackHeightControl.invalid">{{getRequiredNumberErrorMessage(rackHeightControl)}}</mat-error>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="building">
        <mat-header-cell *matHeaderCellDef> {{'Building Number' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let element">

          <mat-select [formControl]="selectedBuildingNumber" name="selectedBuildingNumber">
            <mat-option *ngFor="let building of buildingNumberList" [value]="building">{{building}}</mat-option>
          </mat-select>

        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="shelfCount">
        <mat-header-cell *matHeaderCellDef> {{'Shelf Count' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-form-field>
            <input matInput [value]="element.shelfCount" name="shelfCount" [formControl]="rackShelfCountControl"  [(ngModel)]="element.shelfCount">
            <mat-error *ngIf="rackShelfCountControl.invalid">{{getRequiredNumberErrorMessage(rackShelfCountControl)}}</mat-error>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="columnCount">
        <mat-header-cell *matHeaderCellDef> {{'Column Count' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-form-field>
            <input matInput [value]="element.columnCount"  name="columnCount" [formControl]="rackColumnCountControl" [(ngModel)]="element.columnCount">
            <mat-error *ngIf="rackColumnCountControl.invalid">{{getErrorMessage(rackColumnCountControl)}}</mat-error>
          </mat-form-field>
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedRackColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedRackColumns;"></mat-row>
    </mat-table>
    <div mat-dialog-actions class="fileUploadActionButtons">
      <div>
        <button class="cancelButton" mat-button (click)="onNoClick()">{{'Cancel' | translate}}</button>
        <button  class="okButton" [disabled]="rackEditForm.invalid"  mat-button (click)="confirmEdit(data.type)" cdkFocusInitial>{{'Update' | translate}}</button>
      </div>
    </div>
    </form>
  </div>

  <!-- *********Edit Rack Success Sections**** -->

  <div *ngIf="editRackSuccess && !editRackError">
    <h1 mat-dialog-title>{{'Rack Code Updated Successfully' | translate}}</h1>
    <div mat-dialog-actions class="fileUploadActionButtons">
      <div>
        <button class="okButton" mat-button (click)="closePopup()">{{'Close' | translate}}</button>
      </div>
    </div>
  </div>

  <!-- *********Edit Rack Error Sections**** -->

  <div *ngIf="editRackError">
    <h1 class="errorHead">{{'Error found' | translate}}</h1>
    <div  class="errorsList" *ngIf="editRackErrorMessage.length">
    <div *ngFor="let element of editRackErrorMessage">
      <p class="errorDetails">{{element}}</p>
    </div>
    </div>
    <h1 class="errorHead" mat-dialog-title>{{'Please recheck the fields and edit again' | translate}}</h1>
    <div mat-dialog-actions class="fileUploadActionButtons">
      <div>
        <button class="okButton" mat-button (click)="closePopup()">{{'Close' | translate}}</button>
      </div>
    </div>
  </div>

</div>


<!-- ***********************************Nouba Code Table Editing Section******************************* -->

<div *ngIf="data.type === 'EditNouba'">
  <div *ngIf="!noubaEditingWindow && !editNoubaSuccess && !editNoubaError">
    <h3>{{getEditMessage('nouba')}}
      <!-- {{'Do you want to edit nouba information for' | translate}} "{{data.noubaData.noubaCode}}" -->
    </h3>
    <div mat-dialog-actions class="fileUploadActionButtons">
      <div>
        <button class="cancelButton" mat-button (click)="onNoClick()">{{'Cancel' | translate}}</button>
        <button class="okButton" mat-button (click)="confirmEditProcess()" cdkFocusInitial>{{'Yes' | translate}}</button>
      </div>
    </div>
  </div>


  <div class="noubaEdit" *ngIf="noubaEditingWindow && !editNoubaSuccess && !editNoubaError">
      <form class="form" name="noubaEditForm" [formGroup]="noubaEditForm" >
    <h1 mat-dialog-title>{{'Edit Nouba Code' | translate}}</h1>
    <mat-table #table [dataSource]="dataSource">

      <ng-container matColumnDef="noubaCode">
        <mat-header-cell *matHeaderCellDef>{{'Nouba Code' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-form-field>
            <input matInput [value]="element.noubaCode" name="noubaCode" [formControl]="noubaCodeControl" [(ngModel)]="element.noubaCode">
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="drivingDirection">
        <mat-header-cell *matHeaderCellDef> {{'Driving Direction' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-form-field>
            <input matInput [value]="element.drivingDirection" name="drivingDirection" [formControl]="noubadrivingDirectionControl" [(ngModel)]="element.drivingDirection">
            <mat-error *ngIf="noubadrivingDirectionControl.invalid">{{getRequiredNumberErrorMessage(noubadrivingDirectionControl)}}</mat-error>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="x">
        <mat-header-cell *matHeaderCellDef> {{'Coordinate X' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-form-field>
            <input matInput [value]="element.x" name="x" [formControl]="noubaXControl" [(ngModel)]="element.x">
            <mat-error *ngIf="noubaXControl.invalid">{{getRequiredNumberErrorMessage(noubaXControl)}}</mat-error>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="y">
        <mat-header-cell *matHeaderCellDef> {{'Coordinate Y' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-form-field>
            <input matInput [value]="element.y" name="y" [formControl]="noubaYControl"  [(ngModel)]="element.y">
            <mat-error *ngIf="noubaYControl.invalid">{{getRequiredNumberErrorMessage(noubaYControl)}}</mat-error>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="depth">
        <mat-header-cell *matHeaderCellDef> {{'Size Depth(x)' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-form-field>
            <input matInput [value]="element.depth" name="depth" [formControl]="noubaDepthControl" [(ngModel)]="element.depth">
            <mat-error *ngIf="noubaDepthControl.invalid">{{getRequiredNumberErrorMessage(noubaDepthControl)}}</mat-error>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="width">
        <mat-header-cell *matHeaderCellDef> {{'Size Width(y)' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-form-field>
            <input matInput [value]="element.width" name="width" [formControl]="noubaWidthControl" [(ngModel)]="element.width">
            <mat-error *ngIf="noubaWidthControl.invalid">{{getRequiredNumberErrorMessage(noubaWidthControl)}}</mat-error>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="building">
        <mat-header-cell *matHeaderCellDef> {{'Building Number' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let element">


          <mat-select [formControl]="selectedBuildingNumber" name="selectedBuildingNumber">
            <mat-option *ngFor="let building of buildingNumberList" [value]="building">{{building}}</mat-option>
          </mat-select>

        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedNoubaColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedNoubaColumns;"></mat-row>
    </mat-table>
    <div mat-dialog-actions class="fileUploadActionButtons">
      <div>
        <button class="cancelButton" mat-button (click)="onNoClick()">{{'Cancel' | translate}}</button>
        <button class="okButton" [disabled]="noubaEditForm.invalid"  mat-button (click)="confirmEdit(data.type)" cdkFocusInitial>{{'Update' | translate}}</button>
      </div>
    </div>
    </form>
  </div>


  <div *ngIf="editNoubaSuccess && !editNoubaError">
    <h1 mat-dialog-title>{{'Nouba Code Updated Successfully' | translate}}</h1>
    <div mat-dialog-actions class="fileUploadActionButtons">
      <div>
        <button class="okButton" mat-button (click)="closePopup()">{{'Close' | translate}}</button>
      </div>
    </div>
  </div>

  <div *ngIf="editNoubaError">
    <h1 class="errorHead">{{'Error found' | translate}}</h1>
    <div  class="errorsList" *ngIf="editNoubaErrorMessage.length">
    <div *ngFor="let element of editNoubaErrorMessage">
      <p class="errorDetails">{{element}}</p>
    </div>
    </div>
    <h1 class="errorHead" mat-dialog-title>{{'Please recheck the fields and edit again' | translate}}</h1>
    <div mat-dialog-actions class="fileUploadActionButtons">
      <div>
        <button class="okButton" mat-button (click)="closePopup()">{{'Close' | translate}}</button>
      </div>
    </div>
  </div>

</div>
